/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Classification_Import_ActionInputs */

const en_classification_import_action = /** @type {(inputs: Classification_Import_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from CSV`)
};

const nl_classification_import_action = /** @type {(inputs: Classification_Import_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importeren uit CSV`)
};

/**
* | output |
* | --- |
* | "Import from CSV" |
*
* @param {Classification_Import_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const classification_import_action = /** @type {((inputs?: Classification_Import_ActionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Classification_Import_ActionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_classification_import_action(inputs)
	return en_classification_import_action(inputs)
});